import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { PenLine, LayoutTemplate, Wand2 } from 'lucide-react';

const TABS = [
  {
    to: '/copy',
    label: 'Textos',
    icon: LayoutTemplate,
    end: true,
    desc: 'Edita, genera y traduce los textos de los listings',
  },
  {
    to: '/copy/prompts',
    label: 'Prompts IA',
    icon: Wand2,
    end: false,
    desc: 'Instrucciones que sigue la IA al escribir y traducir los textos',
  },
];

/**
 * Sección Copy: lo que antes era la app aparte copy.tusereno.es (Copywriter
 * Manager), traído al CRM.
 *
 * El historial de generaciones no es una pestaña porque solo tiene sentido con
 * un listing seleccionado: vive dentro del editor, como en la app original.
 */
export default function CopyLayout() {
  const { pathname } = useLocation();
  const activa = TABS.find(t => (t.end ? pathname === t.to : pathname.startsWith(t.to))) ?? TABS[0];

  return (
    <div>
      <div className="flex items-center gap-3 mb-4">
        <div className="p-2 rounded-lg bg-sereno-blue/50 text-sereno-dark">
          <PenLine size={22} />
        </div>
        <div>
          <h1 className="text-2xl font-bold">Copy</h1>
          <p className="text-sm text-sereno-dark/50">{activa.desc}</p>
        </div>
      </div>

      <div className="border-b border-slate-200 dark:border-white/10 mb-6">
        <nav className="flex gap-1 -mb-px overflow-x-auto -mx-4 px-4 sm:mx-0 sm:px-0 scrollbar-none">
          {TABS.map(({ to, label, icon: Icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) =>
                `flex items-center gap-1.5 px-3 sm:px-4 py-3 sm:py-2.5 text-sm whitespace-nowrap border-b-2 transition-colors ${
                  isActive
                    ? 'border-sereno-dark text-sereno-dark font-medium dark:border-white dark:text-white'
                    : 'border-transparent text-slate-500 hover:text-slate-700 dark:hover:text-slate-300'
                }`
              }
            >
              <Icon size={15} />
              {label}
            </NavLink>
          ))}
        </nav>
      </div>

      <Outlet />
    </div>
  );
}
